import type { TFunction } from 'i18next'

import { paths } from 'src/router'

export const getAuthPageTitle = (
  pathname: string,
  t: TFunction
): string | undefined => {
  switch (pathname) {
    case paths.auth.login:
    case paths.auth.loginPassword:
    case paths.auth.googleCallback:
    case paths.auth.googleClientCallback:
    case paths.auth.appleCallback:
    case paths.auth.appleClientCallback:
      return t('welcome_back')

    case paths.auth.register:
      return t('welcome_to_skalx')

    case paths.auth.confirmRegister:
      return t('registration_confirm_title')

    case paths.auth.resetPassword:
      return t('forgot_password')

    case paths.auth.resetPasswordConfirm:
      return t('reset_password')

    case paths.auth.confirmMfaOtp:
      return t('auth.mfa.otpTitle')

    case paths.auth.confirmMfaBackupCode:
      return t('auth.mfa.backupCodeTitle')

    case paths.auth.loginEmail:
    case paths.auth.emailOtpVerify:
      return t('auth.emailOtp.title')

    case paths.auth.emailOtpLink:
      return t('auth.emailOtp.linkCallback.verifying')

    case paths.auth.organizations:
      return t('please_select_organization')

    case paths.auth.googleConnectCallback:
    case paths.auth.googleClientConnectCallback:
    case paths.auth.entraIdConnectCallback:
    case paths.auth.entraIdOrgConnectCallback:
    case paths.auth.appleConnectCallback:
    case paths.auth.appleClientConnectCallback:
    case paths.auth.appleOrgConnectCallback:
      return t('shell.account.authentication')

    default:
      return undefined
  }
}
